"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center px-4">
      <h1 className="text-4xl font-bold">{t("common.error")}</h1>
      <p className="text-muted-foreground max-w-sm">
        {t("common.unexpectedError")}
      </p>
      <Button onClick={reset}>{t("common.tryAgain")}</Button>
    </div>
  );
}
